import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 55271063-77EF-43FA-917C-657E57135A24
 * name flag
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag.svg
 * tags
 */
export const FlagIcon = createSvgIcon(<><path d="M14.4,6L14,4H5V21H7V14H12.6L13,16H20V6H14.4Z" /></>, 'FlagIcon');
export default FlagIcon